import { FC } from 'react';
import { AlertStatus } from '@chakra-ui/react';

import { CircleIcon } from 'features/Bento/atoms';
import { CircleIconProps } from 'features/Bento/atoms/CircleIcon/CircleIcon';
import { ShineIcon } from 'features/Bento/atoms/Icon/Icon';

const STATUS_ICONS: Record<AlertStatus, ShineIcon> = {
  error: 'close',
  info: 'info',
  loading: 'info',
  success: 'check',
  warning: 'warning',
} as const;

const STATUS_COLORS: Record<AlertStatus, string> = {
  error: 'red.-1',
  info: 'blue.-1',
  loading: 'blue.-1',
  success: 'turquoise.-1',
  warning: 'orange.-1',
} as const;

const STATUS_BACKGROUND_COLORS: Record<AlertStatus, string> = {
  error: 'red.3',
  info: 'blue.3',
  loading: 'blue.3',
  success: 'turquoise.3',
  warning: 'orange.3',
} as const;

/**
 * A pre-configured CircleIcon corresponding to a status.
 */
const OBCircleStatus: FC<
  Omit<CircleIconProps, 'name'> & {
    status: AlertStatus;
  }
> = ({ status, ...props }) => (
  <CircleIcon
    background={STATUS_BACKGROUND_COLORS[status]}
    color={STATUS_COLORS[status]}
    name={STATUS_ICONS[status]}
    {...props}
  />
);

export default OBCircleStatus;
